<script setup lang="ts">
import "@/assets/styles/legal.css";
import SidebarComponent from "@/components/SidebarComponent.vue";
import FooterImpressum from "@/components/FooterImpressum.vue";
</script>

<template>

  <section class="legal-page">

    <div class="legal-container">

      <span class="legal-badge">
        Impressum
      </span>

      <h1>
        Angaben gemäß § 5 TMG
      </h1>

      <!-- Firma -->
      <div class="legal-card">

        <h2>Unternehmen</h2>

        <p>
          TestGarten<br>
          Garten- & Landschaftsbau<br>
          Max Mustermann
        </p>

      </div>

      <!-- Adresse -->
      <div class="legal-card">

        <h2>Adresse</h2>

        <p>
          Musterstraße 12<br>
          65183 Wiesbaden<br>
          Deutschland
        </p>

      </div>

      <!-- Kontakt -->
      <div class="legal-card">

        <h2>Kontakt</h2>

        <p>
          Telefon: +49 123 456789<br>
          E-Mail: info@testgarten.de
        </p>

      </div>

      <!-- Verantwortlich -->
      <div class="legal-card">

        <h2>Verantwortlich für den Inhalt</h2>

        <p>
          Max Mustermann<br>
          Musterstraße 12<br>
          65183 Wiesbaden
        </p>

      </div>

      <!-- Hinweis -->
      <div class="legal-card">

        <h2>Haftungshinweis</h2>

        <p>
          Trotz sorgfältiger inhaltlicher Kontrolle übernehmen wir
          keine Haftung für die Inhalte externer Links.
          Für den Inhalt der verlinkten Seiten sind ausschließlich
          deren Betreiber verantwortlich.
        </p>

      </div>

    </div>

  </section>
  <SidebarComponent/>
  <FooterImpressum/>

</template>

<style scoped>
</style>